import React from 'react';

interface Props {
  country?: string;
}

const Privacy = ({ country }: Props) => (
  <>
    {country === 'BR' && (
      <>
        <div>
          <p>Rappi BR.</p>

          <p>
            <b>
              Aviso de Privacidade e <br />
              Políticas de uso das Informação utilizadas pela Rappi
            </b>
          </p>

          <p>
            Este documento, denominado Política de Privacidade, possui finalidade de estabelecer as regras sobre o uso,
            armazenamento e tratamento dos dados e informações coletadas dos USUÁRIOS na PLATAFORMA RAPPI.
          </p>

          <p>
            Responsáveis pelas Informações dos USUÁRIOS:&nbsp;
            <b>RAPPI BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA.</b>, registrada sob o CNPJ 26.900.161/0001-25, com sede na
            Av. dos Autonomistas, 896, torre 1, cj 1211, Vila Yara, Osasco/SP, Brasil, CEP. 06020-010 e suas filiadas
            (“RAPPI”).
          </p>

          <p>
            Quando Você acessar, utilizar ou interagir com a Plataforma, podemos coletar Dados Pessoais sobre Você. Este
            documento (que também chamaremos de “Política de Privacidade” ou simplesmente de “Política”) tem o propósito
            de esclarecer como Dados Pessoais podem ser coletados, usados, compartilhados, armazenados na e de qualquer
            forma tratados na nossa operação da Plataforma.
          </p>

          <p>
            <b>1.Definições importantes:</b>
          </p>

          <p>
            <b>ARRANJO DE PAGAMENTO VISA</b>: é o arranjo de pagamento instituído pela Visa, empresa responsável pela
            marca e pelos sistemas físicos e digitais que permitem a emissão do Cartão e utilização em diferentes
            estabelecimentos credenciados, de acordo com a Lei nº 12.865/2013, e com o{' '}
            <em>Regulamento dos Arranjos de Pagamento da Visa do Brasil</em>, disponível no site da Visa, realizados
            através de RappiPay cartão.
          </p>

          <p>
            <b>BANCO DE DADOS:</b>&nbsp;Conjunto estruturado de dados pessoais ou anônimizados, localizado em um ou em
            vários locais, em suporte eletrônico ou físico;
          </p>

          <p>
            <b>CARTÃO:</b> é um cartão físico e/ou virtual que, a critério da RAPPI, pode ser oferecido aos Consumidores
            para usufruírem de serviços financeiros.
          </p>

          <p>
            <b>CONSENTIMENTO:</b>&nbsp;É a manifestação livre, informada e inequívoca pela qual o USUÁRIO concorda com o
            tratamento dos seus Dados Pessoais para finalidades específicas.
          </p>

          <p>
            <b>CONSUMIDORES</b>: São as pessoas naturais que se cadastraram na Plataforma e a utilizam para solicitar a
            realização de Encargos.
          </p>

          <p>
            <b>CONTA</b>: Uma vez realizado e aprovado o cadastro do Consumidor, será criada uma conta de pagamento na
            estrutura da RAPPI para viabilizar a execução de transações de pagamento mediante gestão dos valores
            aportados pelo Consumidor.{' '}
          </p>

          <p>
            <b>CONTEÚDO</b>: Qualquer informação, dados, comunicações, software, fotos, vídeos, gráficos, música, sons e
            outros materiais e serviços que podem ser visualizados pelos USUÁRIOS na PLATAFORMA. Isso inclui mensagens,
            conversas, bate-papo e outros conteúdos originais.
          </p>

          <p>
            <b>COOKIES:</b>&nbsp;Arquivos enviados pelo servidor da PLATAFORMA para o dispositivo do USUÁRIO, com a
            finalidade de identificar o seu dispositivo e obter dados de acesso, como páginas navegadas ou links
            clicados, permitindo, desta forma, personalizar a utilização da PLATAFORMA, de acordo com o seu perfil.
            Também podem ser utilizados para garantir uma maior segurança dos USUÁRIOS da PLATAFORMA.{' '}
            <em>
              Para mais informações sobre como Cookies e tecnologias similares são utilizadas pela Rappi, por favor
              consulte a nossa{' '}
            </em>
            <a href="https://legal.rappi.com/brazil/politica-de-cookies-brasil/">
              <em>Política de Cookies</em>
            </a>
            <em>.</em>
          </p>

          <p>
            <b>DADOS PESSOAIS</b>: informações relacionadas a uma pessoa natural (identificada ou identificável),
            incluindo números identificativos, dados de localização, identificadores eletrônicos, ou qualquer informação
            que, quando combinada com outras informações, seja capaz de identificar alguém, torná-la identificável ou,
            ainda, individualizá-la.
          </p>

          <p>
            <b>DADOS PESSOAIS ANONIMIZADOS ou ANONIMIZADOS</b>: dados relativos a um USUÁRIO que não possa ser
            identificado.
          </p>

          <p>
            <b>ENCARGOS:</b>&nbsp;são todos os tipos de solicitação que podem ser feitas por Consumidores e realizadas
            por Mandatários por meio da Plataforma, incluindo a aquisição de produtos e a entrega de encomendas. Para
            mais detalhes sobre como funcionam os Encargos, por favor consulte os{' '}
            <a href="https://legal.rappi.com/brazil/termos-e-condicoes-de-uso-da-plataforma-rappi/?_ga=2.115868864.714873495.1570199727-851551344.1569267089&amp;_gac=1.61606238.1570199727.CjwKCAjw29vsBRAuEiwA9s-0B5SnYuBEp3RH0BdqwnuBbqvAEuxPg5e7WOUFl5bxO6SQgt-zoWNEAxoCs1YQAvD_BwE">
              Termos de Uso da Plataforma
            </a>
            .
          </p>

          <p>
            <b>ESTABELECIMENTOS PARCEIROS:</b>&nbsp;são os estabelecimentos comerciais que mantêm relação de parceria
            com a Rappi, a partir dos quais podem ser solicitados pedidos e Encargos para realização pelos Mandatários.
          </p>

          <p>
            <b>IP (Internet Protocol):</b>&nbsp;É um conjunto de números que identifica o computador do USUÁRIO na
            Internet.
          </p>

          <p>
            <b>JANELAS (Pop-Ups):</b>&nbsp;Janela ou aviso da internet que emerge automaticamente em qualquer momento
            quando a PLATAFORMA é utilizada, inclusive na formalização dos Termos e Condições do Uso da Plataforma e na
            Política de Privacidade.
          </p>

          <p>
            <b>LOGS</b>: registros de atividades do USUÁRIO efetuadas na PLATAFORMA.
          </p>

          <p>
            <b>RAPPI</b>: é a empresa proprietária e possuidora de todos os direitos autorais referente a Plataforma de
            Internet denominada RAPPI.
          </p>

          <p>
            <b>PARCEIRA DO ARRANJO DO ARRANJO </b>: é a empresa responsável pela emissão do Cartão, sob o Arranjo de
            Pagamento Visa, que possui uma conta de pagamento atrelada a ele, com saldo zerado, que será entregue pela
            RAPPI.
          </p>

          <p>
            <b>MANDATÁRIOS:</b> compõe uma categoria específica de Usuários, sendo as pessoas naturais parceiras da
            Rappi que se cadastraram na Plataforma e a utilizam para realizar Encargos a pedido de Consumidores.
          </p>

          <p>
            <b>MENSAGENS DE DADOS:</b>&nbsp;A informação gerada, enviada, recebida, armazenada ou comunicada por meios
            eletrônicos, óticos ou similares. Exemplificando: os formulários de cadastramento, o Intercâmbio Eletrônico
            de Dados (EDI – Electronic Data Interchange), Internet, o correio eletrônico, chats entre outros meios de
            comunicação
          </p>

          <p>
            <b>PLATAFORMA RAPPI:</b>&nbsp;aplicativo web e móvel administrado e com os direitos exclusivos de utilização
            no Brasil pela RAPPI, através do qual, em conjunto com a PARCEIRA DO ARRANJO: i) são exibidos diferentes
            produtos de consumo de forma publicitária (dos Prestadores de Serviço) para que possam servir de referência
            ao Consumidor; ii) facilita a aproximação entre os Consumidores e os Prestadores de Serviço; iii) serve como
            meio de envio de comunicações entre o Consumidor e a RAPPI; iv) se aplicável, oferta Cartão e Conta ao
            Consumidor, por meio dos quais este pode movimentar recursos financeiros e realizar transações de pagamento;
            e v) pode receber os pagamentos das compras diretamente do consumidor (por conta e ordem de terceiros), com
            repasse do dinheiro ao Prestador de Serviço. &nbsp;A RAPPI não realiza a compra de produtos por conta
            própria, não armazena produtos e tampouco é vendedora de produtos. É uma plataforma de tecnologia somente
            para intermediação da Venda, cobrando pelos serviços realizados<b>.&nbsp;</b>Também denominada neste
            Instrumento como&nbsp;<b>“PLATAFORMA”,&nbsp;</b>podendo ser acessada por&nbsp;
            <em>computadores, notebooks</em>
            <b>,&nbsp;</b>
            <em>smartphones</em>&nbsp;ou&nbsp;<em>tablets.</em>
          </p>

          <p>
            <b>SERVIÇO ou SERVIÇOS:</b>&nbsp;Serviços oferecidos por meio da PLATAFORMA.
          </p>

          <p>
            <b>SESSION ID</b>: identificação da sessão do USUÁRIO no processo de inscrição ou quando utilizado de alguma
            forma na PLATAFORMA.
          </p>

          <p>
            <b>TERMOS E CONDIÇÕES DE USO DA PLATAFORMA ou TERMOS DE USO</b>: Constituem os termos legais que
            regulamentam a relação entre a RAPPI, a PARCEIRA DO ARRANJO DO ARRANJO&nbsp; e os USUÁRIOS.
          </p>

          <p>
            <b>TRATAMENTO</b>: é qualquer tipo de atividade baseada em Dados Pessoais, incluindo, por exemplo, as
            seguintes atividades: coleta, registro, armazenamento, organização consulta, uso, divulgação,
            compartilhamento, transmissão, classificação, reprodução, processamento e avaliação.
          </p>

          <p>
            <b>USUÁRIO</b>: é a pessoa natural usuária da Plataforma RAPPI, identificada neste Instrumento como USUÁRIO.
          </p>

          <p>
            <b>USUÁRIO DA PLATAFORMA RAPPI</b>: são as pessoas físicas cadastradas na Plataforma de Internet
            denominada&nbsp;<b>RAPPI&nbsp;</b>também denominados&nbsp;<b>“USUÁRIO”</b>,
            <b>&nbsp;“USUÁRIOS”, “TITULAR DO DADO” ou “VOCÊ”. </b>
          </p>

          <p>
            A <b>RAPPI</b> e o <b>USUÁRIO</b> poderão ser mencionados individualmente neste Instrumento como “Parte” ou
            em conjunto como “Partes”.
          </p>

          <p>
            <b>2.Obtenção e Uso dos Dados e Informações dos Usuários:</b>
          </p>

          <p>
            Os dados e informações (sejam eles PESSOAIS ou ANONIMIZADOS) serão obtidos quando o USUÁRIO: (a) Passar a
            utilizar os SERVIÇOS da PLATAFORMA; (b) Interagir com as diversas ferramentas existentes na PLATAFORMA,
            fornecendo as informações voluntariamente ou involuntariamente (no caso de obtenção de informações sobre a
            frequência de utilização da PLATAFORMA ou os tipos de informações envolvidas; ou (c) Entrar em contato por
            meio dos canais de comunicação disponíveis na PLATAFORMA.{' '}
          </p>

          <p>
            Com exceção do disposto no item 4 desta Política abaixo, a RAPPI e a PARCEIRA DO ARRANJO DO ARRANJO não
            alugam, não vendem e não compartilham as informações pessoais com outras pessoas ou com empresas não
            afiliadas, exceto com o objetivo de fornecer ao USUÁRIO os produtos e serviços solicitados na PLATAFORMA,
            tendo obtido para tanto a sua permissão, ou em circunstâncias específicas, como ordem judicial ou advindas
            de lei.
          </p>

          <p>
            Poderão ser solicitados dos USUÁRIOS do <b>ARRANJO DE PAGAMENTO VISA</b>, dentre outros, os seguintes dados:
            CPF/CNPJ, nome completo, data de nascimento, endereço residencial, endereço de e-mail, nome completo da mãe
            e número de telefone, cópia de documento de identidade ou de Carteira Nacional de Habilitação, “selfie”,
            autodeclaração de Pessoa Exposta Politicamente (se aplicável), IP, hora e data de acesso, geolocalização,
            dados sobre o dispositivo de acesso e cookies, perfil e comportamento de compra, volume e número de
            transações e por meio da Plataforma, dados gerais de navegabilidade, utilização da Plataforma e funis de
            eventos.
          </p>

          <p>
            <b>3.Prazos de Armazenamento dos Dados e Informações</b>:
          </p>

          <p>
            Todas as MENSAGENS DE DADOS e informações coletadas dos USUÁRIOS serão incorporados ao BANCO DE DADOS da
            PLATAFORMA, sendo seus responsáveis e proprietários a RAPPI e a PARCEIRA DO ARRANJO. Os dados e informações
            coletados estarão armazenados em ambiente seguro, observado o estado da técnica disponível e criptografados,
            e somente poderão ser acessados por pessoas qualificadas e autorizadas pela RAPPI e/ou pela PARCEIRA DO
            ARRANJO. Considerando que nenhum sistema de segurança é absolutamente seguro, a RAPPI e a PARCEIRA DO
            ARRANJO DO ARRANJO se eximem de quaisquer responsabilidades por eventuais danos e/ou prejuízos decorrentes
            de falhas, vírus ou invasões do BANCO DE DADOS na PLATAFORMA.{' '}
          </p>

          <p>
            Nós manteremos seus Dados Pessoais somente pelo tempo que for necessário para cumprir com as finalidades
            para as quais os coletamos, inclusive para fins de cumprimento de quaisquer obrigações legais, contratuais,
            de prestação de contas ou requisição de autoridades competentes.
          </p>

          <p>
            Para determinar o período de retenção adequado para cada tipo de Dado Pessoal tratado pela Rappi, sempre
            consideramos a quantidade, a natureza e a sensibilidade de tais Dados, o risco potencial de danos
            decorrentes do seu uso não autorizado ou da sua divulgação, a finalidade do tratamento e se podemos alcançar
            tais propósitos por outros meios, e os requisitos legais aplicáveis.
          </p>

          <p>
            <b>4.Uso dos Dados e Informações:</b>
          </p>

          <p>
            A quantidade e o tipo de Dados Pessoais coletados pela Rappi variam conforme o seu uso da Plataforma.
            Coletaremos diferentes Dados caso você seja um Consumidor utilizando a Plataforma, um Mandatário ou um
            representante de um dos nossos Estabelecimentos Parceiros.{' '}
          </p>

          <p>
            Para esclarecer essas questões, listamos abaixo algumas finalidades para as quais seus Dados podem ser
            utilizados, dependendo da sua forma de utilização da Plataforma, para que você possa entender o que se
            aplica especificamente a você:
          </p>

          <ul>
            <li>
              <b>Consumidores</b>: Caso você use a Plataforma como um Consumidor, isto é, um Usuário que envia Encargos
              para que a Rappi possa conectá-lo a um Mandatário para que este possa, por sua vez, atender ao seu pedido
              e realizar o seu Encargo, poderemos coletar Dados a partir da sua utilização da Plataforma e do seu
              cadastro, conforme detalhado a seguir:
              <br /> <br />
              <u>Cadastro na Plataforma</u>
              <br />
              <br />
              <b>Tipo de Dados Coletados: </b>
              <b>Dados de cadastro</b>: nome, e-mail, telefone, endereço de entrega, CPF, número do cartão para
              pagamento (quando este é o método de pagamento) e, quando for solicitado um Cartão, CNH, data de
              nascimento, endereço residencial, nome da mãe, foto e autodeclaração de Pessoa Exposta Politicamente.
              <br />
              <br />
              <b>Finalidade: </b> Cadastro na Plataforma, solicitação e entrega de pedidos, realização de operações de
              pagamento, envio de comprovantes de pedidos, envio de brindes, contatos telefônico (ligação, SMS, push e
              WhatsApp) e emissão do Cartão.
              <br />
              <br />
              <u>Interação com a Plataforma</u>
              <br />
              <br />
              <b>Tipo de Dados Coletados: </b>
              <b>Dados de navegação</b>: endereço do IP, IMEI do dispositivo do Usuário, dados locacionais e
              comportamento de consumo na Plataforma para análise de preferências. &nbsp;
              <b>Dados sobre o dispositivo de acesso</b>: endereço do IP, IMEI do dispositivo do usuário e dados
              locacionais.
              <br />
              <br />
              <b>Finalidade: </b> Análise do perfil de consumo, perfilhamento para fins de inteligência de mercado e
              envio de publicidade própria e de terceiros.
            </li>
          </ul>

          <ul>
            <li>
              <b>Mandatários</b>: Caso você use a Plataforma como um Mandatário, isto é, um Usuário que realiza Encargos
              para atender às solicitações de Consumidores, poderemos coletar Dados a partir da sua utilização da
              Plataforma e do seu cadastro, conforme detalhado a seguir:
              <br /> <br />
              <u>Cadastro na Plataforma</u>
              <br />
              <br />
              <b>Tipo de Dados Coletados: </b>
              <b>Dados de cadastro</b>: nome, e-mail, RG, CPF, CNH, placa da moto (quando aplicável) e endereço
              residencial, dados bancários (banco agência e conta corrente)
              <br />
              <br />
              <b>Finalidade: </b> Cadastro na Plataforma, solicitação e entrega de pedidos, realização de operações de
              pagamento, contatos telefônico (ligação, SMS, push e WhatsApp), envio de comprovantes de pedidos e envio
              de brindes. &nbsp; Análise do perfil do Mandatário, verificação do cumprimento dos Encargos e envio de
              publicidade.
              <br />
              <br />
              <u>Interação com a Plataforma</u>
              <br />
              <br />
              <b>Tipo de Dados Coletados: </b> <b>Dados sobre o dispositivo de acesso</b>: endereço do IP, IMEI do
              dispositivo e geolocalização no momento da entrega <br />
              <br />O aplicativo ‘Soy Rappi’ coleta e armazena o número de telefone do usuário que é armazenado em nosso
              banco de dados usando métodos de criptografia para garantir a proteção das informações pessoais do
              usuário. Os dados coletados são usados ​​para identificar possíveis comportamentos atípicos dentro do
              aplicativo e não são compartilhados ou transferidos a terceiros.
            </li>
          </ul>

          <ul>
            <li>
              <b>Representantes de Estabelecimentos Parceiros</b>: Caso você use a Plataforma como um representante de
              um dos nossos Estabelecimentos Parceiros, isto é, um Usuário que recebe pedidos realizados por
              Consumidores para preparo e posterior entrega a um Mandatário designado pela Rappi, poderemos coletar
              Dados a partir da sua utilização da Plataforma e do seu cadastro, conforme detalhado a seguir:
              <br /> <br />
              <u>Cadastro na Plataforma e Formalização de Contrato</u>
              <br />
              <br />
              <b>Dados de cadastro</b>: nome do representante legal e CPF, número de telefone do representante, dados
              bancários (banco, agência e conta corrente), endereço do IP e IMEI do dispositivo do responsável pela
              assinatura do contrato.
              <br />
              <br />
              <b>Finalidade: </b> Cadastro na Plataforma, cumprimento da parceria comercial e criação da loja virtual do
              Estabelecimento Parceiro na Plataforma.
            </li>
          </ul>

          <p>
            Os registros mencionados poderão ser utilizados pela RAPPI em casos de investigação de fraudes ou de
            alterações indevidas em seus sistemas e cadastros, assim como no compartilhamento com terceiros de forma
            anonimizada.
          </p>

          <p>
            <b>5.COM QUEM A RAPPI COMPARTILHA DADOS PESSOAIS?</b>
          </p>

          <p>
            Para viabilizar a operação da Plataforma, a Rappi depende de relações específicas com diferentes pessoas,
            incluindo parceiros de negócio. Nessas relações, é possível que Dados Pessoais sejam compartilhados para
            suportar o regular funcionamento da Plataforma, como no contexto da prestação de serviços de hospedagem de
            dados, por exemplo. Desta forma, nos reservamos o direito de compartilhar seus Dados Pessoais com os grupos
            de recipientes abaixo indicados, sempre respeitando a legislação brasileira, e adotaremos as medidas
            jurídicas, técnicas e organizacionais adequadas visando à preservação da sua privacidade e da integridade de
            seus Dados Pessoais.
          </p>

          <p>
            Listamos abaixo os contextos nos quais compartilhamos Dados Pessoais, as finalidades de cada
            compartilhamento e os respectivos recipientes dos Dados em cada caso:
            <br /> <br />
            <u>
              Recipiente dos Dados: <b>Mandatários</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Nome, endereço e detalhes sobre Encargos solicitados na Plataforma
            pelos Consumidores
            <br />
            <br />
            <b>Finalidade do Compartilhamento: </b> Mandatários têm acesso a tais Dados Pessoais de Consumidores durante
            a realização dos Encargos para que possam realizá-los corretamente, na forma solicitada pelos Consumidores.
            Nota: Os detalhes de Encargos referentes a produtos específicos adquiridos por Consumidores só são
            compartilhados com Mandatários quando os Mandatários devem selecionar, adquirir e retirar os produtos
            desejados pelos Consumidores nos Estabelecimentos Parceiros.
            <br /> <br />
            <u>
              Recipiente dos Dados: <b>Consumidores</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Nome, dados de localização e placa da moto dos Mandatários
            <br />
            <br />
            <b>Finalidade do Compartilhamento: </b>Consumidores têm acesso a tais Dados Pessoais de Mandatários para que
            possam acompanhar a realização dos Encargos solicitados e interagir com os Mandatários com segurança,
            podendo facilmente identificá-los e, havendo necessidade, interagir com estes.
            <br /> <br />
            <u>
              Recipiente dos Dados: <b>Estabelecimentos Parceiros</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Detalhes sobre pedidos realizados na Plataforma, CPF (caso queira
            este dado na fatura ou trate-se de dado obrigatório para faturamento – ex. NF-e), primeiro nome do
            Consumidor e primeiro nome do Mandatário
            <br />
            <br />
            <b>Finalidade do Compartilhamento: </b>Estabelecimentos Parceiros recebem estes Dados para garantir o
            correto atendimento dos pedidos dos Consumidores e a correta identificação dos Mandatários para viabilizar a
            entrega dos produtos adquiridos e emissão de Nota Fiscal. Nota: O nome, o e-mail, o telefone e demais Dados
            dos Consumidores só são compartilhados com os Estabelecimentos Parceiros mediante o consentimento específico
            e destacado do Consumidor, para finalidades específicas, por exemplo, para fins de marketing ou participação
            em programas de fidelidade.
            <br /> <br />
            <u>
              Recipiente dos Dados: <b>Nome completo, endereço e telefone do Consumidor</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Quando o Consumidor utiliza a Plataforma para adquirir produtos cuja
            entrega seja operacionalizada pelos Estabelecimentos Parceiros (e não por Mandatários), tais Dados Pessoais
            também são compartilhados com o Estabelecimento Parceiro envolvido para possibilitar a entrega dos produtos
            selecionados.
            <br />
            <br />
            <u>
              Recipiente dos Dados: <b>Fornecedores de Tecnologia e de Serviços Financeiros</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Todos os Dados Pessoais coletados na Plataforma
            <br />
            <br />
            <b>Finalidade do Compartilhamento: </b>Temos uma série de fornecedores que precisamos contratar para operar
            a Plataforma, e alguns deles podem tratar em nosso nome os Dados Pessoais que coletamos. Por exemplo, temos
            serviços de hospedagem de dados contratados na Amazon Web Services, arranjos de pagamento que possibilitam a
            realização de transações financeiras na Plataforma (incluindo a Visa e o Emissor) e serviços de análise de
            dados que nos permitem entender melhor como a Plataforma é utilizada para que possamos sempre aprimorá-la.
            Nota: A Visa e o Emissor poderão ter acesso aos Dados Pessoais dos Consumidores portadores do Cartão também
            para fins de disponibilização de ofertas, descontos e promoções e para permitir a interação do Consumidor
            com as plataformas promocionais da Visa.
          </p>

          <p>
            Alguns Dados Pessoais tratados na Plataforma também podem ser tratados de forma conjunta pela Rappi com
            outras empresas do seu grupo econômico Rappi para fins de reporte e inteligência de mercado. Nesses casos,
            os Dados Pessoais envolvidos podem ser transferidos para fora do Brasil, mais especificamente para Estados
            Unidos, Colômbia, México, Argentina, Peru, Equador, Chile e Costa Rica.
          </p>

          <p>
            <b>5.Cookies</b>:
          </p>

          <p>
            A PLATAFORMA poderá fazer o uso de COOKIES e tecnologias similares para customizar a experiência dos
            Usuários na Plataforma e para gerar informações relevantes sobre a forma de uso da Plataforma pelos Usuários
            para a Rappi. Para entender como Cookies e tecnologias similares são utilizadas pela Rappi e para exercer
            seus direitos de escolha quanto ao uso de referidas tecnologias na Plataforma, por favor verifique a nossa
            <a href="https://legal.rappi.com/brazil/politica-de-cookies-brasil/"> </a>
            <a href="https://legal.rappi.com/brazil/politica-de-cookies-brasil/">Política de Cookies</a>.
          </p>

          <p>
            <b>6.Direitos do USUÁRIO:</b>
          </p>

          <p>
            Seus Dados Pessoais são seus e a legislação brasileira lhe garante, na sua condição de Titular de Dados
            Pessoais, uma série de direitos relacionados aos seus Dados. Nós estamos comprometidos com o cumprimento
            desses direitos e, nessa seção, explicaremos quais são esses direitos e como você pode exercê-los junto à
            Rappi.{' '}
          </p>

          <ul>
            <li>
              <b>Confirmação de existência de tratamento</b>: Você pode solicitar a nossa confirmação acerca da
              existência ou inexistência de atividades de tratamento dos seus Dados Pessoais.
            </li>
          </ul>

          <ul>
            <li>
              <b>Acesso aos seus Dados Pessoais</b>: Você pode requisitar e receber uma cópia dos seus Dados Pessoais
              que nós possuímos sobre você.
            </li>
          </ul>

          <ul>
            <li>
              <b>Retificação dos seus Dados Pessoais: </b>Você pode solicitar a correção e/ou retificação dos seus Dados
              Pessoais, caso você identifique que alguns deles estão incorretos. Contudo, para ser efetivada essa
              correção, possivelmente precisaremos checar a validade dos Dados que você nos fornecerá.
            </li>
          </ul>

          <ul>
            <li>
              <b>Eliminação dos seus Dados Pessoais: </b>Você pode solicitar a exclusão dos seus Dados Pessoais das
              bases de dados que utilizamos para tratá&nbsp;&nbsp;&nbsp;&nbsp; -los. Todos os Dados coletados serão
              excluídos de nossos servidores quando você assim requisitar ou quando estes não forem mais necessários ou
              relevantes para lhe oferecermos os nossos serviços, salvo se houver qualquer outra razão para a sua
              manutenção, como eventual obrigação legal de retenção de Dados ou necessidade de preservação destes para
              resguardar direitos da Rappi.
            </li>
          </ul>

          <ul>
            <li>
              <b>Objeção ao tratamento de Dados Pessoais</b>:Você pode contestar a nossa forma de tratamento dos seus
              Dados Pessoais para determinadas finalidades. Em certas situações, podemos demonstrar que temos motivos
              legítimos para tratar seus Dados, os quais podem eventualmente se sobrepor aos seus direitos, caso, por
              exemplo, sejam estritamente essenciais para a funcionalidade de determinado aspecto da Plataforma.
            </li>
          </ul>

          <ul>
            <li>
              <b>Portabilidade dos seus Dados Pessoais</b>: Você pode solicitar o fornecimento direto a você (ou a
              terceiros que você escolher) dos seus Dados Pessoais em formato estruturado e interoperável.
            </li>
          </ul>

          <ul>
            <li>
              <b>Revogação do consentimento: </b>Nashipóteses em que você tiver fornecido o seu consentimento para que
              pudéssemos realizar atividades de tratamento específicas com seus Dados Pessoais, você pode retirar o seu
              consentimento. Isso não afetará a legalidade de qualquer atividade realizada anteriormente à sua retirada
              de consentimento. Além disso, se você retirar o seu consentimento, talvez não possamos fornecer
              determinados produtos, serviços, benefícios ou vantagens. Caso isso possa ocorrer, forneceremos
              informações específicas a você para ajudar na sua tomada de decisão.
            </li>
          </ul>

          <ul>
            <li>
              <b>Revisão de decisões automatizadas: </b>Você pode solicitar a revisão de decisões tomadas unicamente com
              base no tratamento automatizado de seus Dados Pessoais que afetem seus interesses.
            </li>
          </ul>

          <p>
            Em alguns casos, você terá a opção de não fornecer certos Dados Pessoais e/ou de não permitir certas formas
            de tratamento (ao não fornecer o seu consentimento para uma finalidade específica, por exemplo). Nesses
            casos, é importante ter em mente que alguns Dados e/ou algumas autorizações específicas que dependem do seu
            consentimento podem ser condição para que você possa usufruir de alguns de nossos produtos, serviços,
            benefícios e facilidades. Sempre que esse for o caso e o tratamento dos seus Dados for condição para
            determinada finalidade, você será informado antes que possa tomar uma decisão sobre isso.
          </p>

          <p>
            Para apresentar uma requisição de exercício de qualquer dos direitos acima, você pode optar pelo uso dos
            meios descritos abaixo para entrar em contato com o encarregado pelo tratamento de dados pessoais da Rappi:{' '}
          </p>

          <p>
            <b>Atendimento Eletrônico:</b>&nbsp;um requerimento deve ser apresentado por meio do envio do requerimento
            atraves do{' '}
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSc-cgyQrYBxwJl683e74KYB5fCeXgAMYHCGCewcZ5ujKONYvQ/viewform">
              Formulário de Exclusão de Conta
            </a>
            .
          </p>

          <p>
            <b>Atendimento Escrito:</b>&nbsp;um requerimento deve ser apresentado por meio do envio de uma solicitação
            escrita endereçada à Rappi, no endereço: Av dos Autonomistas, 896, torre 1, cj 1211, Vila Yara, Osasco/SP,
            Brasil, CEP. 06020-010, sendo necessária a indicação do endereço escolhido para o posterior recebimento de
            notificações e respostas da Rappi.
          </p>

          <p>
            Em qualquer dos casos, para a sua segurança e, para que possamos validar a sua identidade e confirmar que
            você está solicitando Dados Pessoais sobre os quais você efetivamente detém direitos, precisaremos submeter
            a sua requisição a um processo de validação interna de identidade. Durante esse processo, solicitaremos o
            cumprimento dos seguintes requisitos:
          </p>

          <ol>
            <li>
              Você deverá ser o Titular dos Dados sobre os quais você faça algum requerimento, provando sua identidade
              mediante a apresentação de evidências que provem a sua identidade de forma suficiente, de acordo com o
              critério exclusivo da Rappi;
            </li>
            <li>
              Caso você seja um sucessor legítimo de um Usuário na forma da lei, os requisitos do item ‘<b>1</b>’ acima
              deverão ser aplicáveis não somente ao Usuário, mas também a você e à sua condição de sucessor legítimo do
              Usuário; e
            </li>
            <li>
              Caso você seja um representante ou procurador de um Usuário, os requisitos do item ‘<b>1</b>’ acima
              deverão ser aplicáveis não somente ao Usuário, mas também a você e à sua condição de representante ou
              procurador do Usuário. Estes requisitos também se aplicam a representantes legais de crianças,
              adolescentes e incapazes.
            </li>
          </ol>

          <p>
            <b>LIMITAÇÕES AOS DIREITOS DOS USUÁRIOS</b>: EM ALGUNS CASOS, A RAPPI PODE TER MOTIVOS LEGÍTIMOS PARA DEIXAR
            DE ATENDER A UMA SOLICITAÇÃO DE EXERCÍCIO DE DIREITOS. ESSAS SITUAÇÕES INCLUEM, POR EXEMPLO, CASOS EM QUE
            UMA REVELAÇÃO DE INFORMAÇÕES ESPECÍFICAS PODERIA VIOLAR DIREITOS DE PROPRIEDADE INTELECTUAL OU SEGREDOS DE
            NEGÓCIO DA RAPPI OU DE TERCEIROS, BEM COMO CASOS EM QUE PEDIDOS DE ANONIMIZAÇÃO, BLOQUEIO OU ELIMINAÇÃO DE
            DADOS NÃO POSSAM SER ATENDIDOS EM RAZÃO DA EXISTÊNCIA DE OBRIGAÇÃO DA RAPPI DE RETER DADOS, SEJA PARA
            CUMPRIR OBRIGAÇÕES LEGAIS, REGULATÓRIAS OU PARA POSSIBILITAR A DEFESA DE DIREITOS DA RAPPI OU DE TERCEIROS,
            INCLUSIVE EM DISPUTAS DE QUALQUER NATUREZA.
            <br />
            <br />
          </p>

          <p>
            <b>7. Política de Proteção de Dados Pessoais </b>
          </p>

          <p>
            A Rappi sempre planeja e toma medidas técnicas, administrativas e organizacionais para proteger todos os
            Dados Pessoais que trata contra perdas, usos não autorizados ou outras situações ilícitas ou acidentais de
            tratamento indevido. Todos os Dados Pessoais tratados pela Rappi são armazenados e processados em ambientes
            operacionais seguros não acessíveis ao público.
          </p>

          <p>
            Com a finalidade de garantir a segurança de seus Dados Pessoais na nossa operação da Plataforma, adotamos as
            melhores práticas de segurança da informação disponíveis, incluindo o uso de soluções de criptografia ponto
            a ponto para transmitir os Dados Pessoais e outras informações. Não é permitida a utilização de nenhum
            dispositivo, software, ou outro recurso que venha a interferir nas atividades e operações do RAPPI e/ou da
            PARCEIRA DO ARRANJO, bem como nas publicações de oferta, descrições, contas ou seus bancos de dados.
            Qualquer intromissão, tentativa de, ou atividade que viole ou contrarie as leis de direito de propriedade
            intelectual e/ou as proibições estipuladas neste instrumento, tornarão o responsável passível das ações
            legais pertinentes, bem como das sanções aqui previstas, sendo ainda responsável pelas indenizações por
            eventuais danos causados.
          </p>

          <p>
            A entrada ou uso não autorizado de contas, falhas de hardware ou software e outros fatores alheios à vontade
            e ao controle razoável da Rappi podem comprometer a segurança dos seus Dados Pessoais a qualquer momento.
            Por isso, pedimos que você nos ajude a manter um ambiente seguro para todos. Além de manter as suas
            informações de acesso à Plataforma secretas e adotar práticas visando à segurança da sua conta e aos seus
            Dados, pedimos que caso você identifique ou tome conhecimento de algo que comprometa a segurança dos seus
            Dados, por favor entre em contato conosco enviando uma mensagem de e-mail para{' '}
            <a href="mailto:legal.br@rappi.com">legal.br@rappi.com</a>e detalhando a situação para que possamos
            ajudá&nbsp;&nbsp;&nbsp;&nbsp; -lo da melhor forma.
          </p>

          <p>
            <b>8. Das Disposições Gerais:</b>
          </p>

          <p>
            Como estamos sempre buscando melhorar a Plataforma e os nossos serviços, essa Política de Privacidade pode
            passar por atualizações. Desta forma, recomendamos que você visite periodicamente esta página para que tenha
            conhecimento sobre todas as modificações que faremos. Caso sejam feitas alterações relevantes, como aquelas
            que se refiram à necessidade de se obter um consentimento seu, publicaremos essa atualização e solicitaremos
            o seu consentimento, conforme a necessidade de cada caso.{' '}
          </p>

          <p>
            As disposições constantes desta Política de Privacidade poderão ser atualizadas ou modificadas a qualquer
            momento, cabendo ao USUÁRIO verificá-las sempre que efetuar o acesso à PLATAFORMA.
          </p>

          <p>
            <b>9.Lei Aplicável e Jurisdição:</b>
          </p>

          <p>
            A presente Política de Privacidade será interpretada segundo a legislação brasileira, no idioma português,
            sendo eleito o Foro da Comarca de São Paulo para dirimir qualquer litígio, questão ou dúvida superveniente,
            com expressa renúncia de qualquer outro, por mais privilegiado que seja.
          </p>

          <p>
            <b>10. Aceitação Total deste Termo</b>
          </p>

          <p>
            O USUÁRIO declara ter a capacidade legal, dando o seu CONSENTIMENTO expresso dos termos constantes desta
            Política de Privacidade, sendo que aceita a totalidade das situações reguladas neste documento
          </p>
        </div>
      </>
    )}

    {country !== 'BR' && (
      <>
        <div className="box-content">
          <p>
            {' '}
            Netviajes unidad de negocios especializada en proveer servicios turísticos (en adelante “La Agencia” o
            “Netviajes”) valora y se compromete a proteger los datos personales de sus clientes en su calidad de
            responsables o encargados del tratamiento, para ello desarrolló ésta política de privacidad (en adelante
            “Política”), la cual se refiere a la recolección, uso, conservación y divulgación de información personal
            recopilada en desarrollo de su actividad, lo anterior en cumplimiento de Ley de Protección de Datos
            Personales en Colombia, Ley 1581 de 2012, Decreto 1377 de 2013 y sus normas complementarias.
          </p>
          <p>
            {' '}
            Cuando usted accede para realizar de compras se servicios turísticos, nos deja el registro de su información
            personal, la cual puede en ocasiones ser validada previamente por el establecimiento de comercio o bancario
            que lo remite a nuestro sitio web (en adelante “sitio web”). Esta Política pretende ayudarlo a comprender
            qué tipo de datos recopilamos, porque lo hacemos y cuál es su destinación.
          </p>
          <p>
            {' '}
            De esta forma, siendo usted el usuario, titular o autorizado a suministrar datos personales en este sitio
            web, otorga autorización para realizar las prácticas que a continuación se detallan, por lo que lo invitamos
            a leer atentamente la siguiente información:
          </p>
          <p>
            {' '}
            El responsable a título propio o en calidad de encargado de la base de datos recopilada a través del sitio
            web es Netactica Colombia SAS con NIT 900132867-1 a través de su unidad de negocios especializada Netviajes
            ubicada en la Carrera 15 # 88 21 oficina 502 en la ciudad de Bogotá.
          </p>
          <h4>1. DATOS RECOPILADOS</h4>
          <ul>
            <li>
              <b>Información que usted nos proporciona</b>
              <p>
                Netviajes recibe y almacena ésta información para poder realizar reservas turísticas, para realizar este
                trámite usted debe proporcionarnos cierta información personal (en adelante la “Información Personal”)
                que incluye nombre y apellido, número de documento o identificación válida, nacionalidad, en algunas
                ocasiones clave de identificación tributaria, e información de contacto (como número telefónico,
                domicilio o dirección de correo electrónico).
              </p>
              <p>
                A fin de formalizar reservas turísticas y de acuerdo con el medio de pago seleccionado por usted, en
                ocasiones debe además brindarnos la información sobre su tarjeta de débito o crédito (tal como el número
                de la tarjeta de crédito, el código de seguridad, el nombre del titular de la tarjeta y la fecha de
                vencimiento).
              </p>
              <p>
                A criterio exclusivo de La Agencia podrá corroborar la información personal suministrada por usted,
                acudiendo a consultarla ante entidades públicas, compañías especializadas o centrales de riesgo para lo
                cual usted nos autoriza expresamente a tratar en forma confidencial. En general la información personal
                solicitada en el sitio web es indispensable para generar las reservas turísticas, usted decide si
                suministra de manera voluntaria dicha información, en caso contrario es posible que usted no pueda
                contratar con nosotros.
              </p>
              <p>
                En caso que Usted realice una reserva en nombre de otra persona, deberá obtener previamente el
                consentimiento de dicha persona antes de otorgarnos la Información Personal de ésta. Si esa persona es
                menor de edad según la ley aplicable, usted declara tener facultades suficientes para brindar dicha
                Información Personal y aceptar esta Política.
              </p>
            </li>
            <li>
              <b>Información de terceros</b>
              <p>
                {' '}
                En la medida permitida por la Ley, Netviajes también podrá obtener Información Personal sobre usted y
                añadirla a la Información Personal que usted nos proporciona ya sea de entidades afiliadas, socios
                comerciales y otras fuentes de terceros independientes –a quienes usted previamente autorizo a tratar
                sus datos personales como ser bases de datos públicas. Cualquier Información Personal obtenida por
                Netviajes por los medios aquí mencionados será tratada de conformidad con las disposiciones de esta
                Política.
              </p>
            </li>
            <li>
              <b> Información que recopilan nuestros sistemas </b>
              <p>
                {' '}
                Netviajes recoge y almacena automáticamente cierta información sobre la actividad de sus usuarios. Tal
                información puede incluir la URL de la que provienen (estén o no en el Sitio Web de Netviajes), a qué
                URL acceden seguidamente, qué navegador están usando, y sus direcciones IP. También las páginas
                visitadas y las búsquedas realizadas .Para que el Sitio Web funcione correctamente, Netviajes utiliza
                cookies propias y de terceros.
              </p>
            </li>
          </ul>
          <h3>Información sobre las cookies y las web beacons</h3>
          <p>
            Las cookies son tipos específicos de información que un sitio web transmite al disco duro de la computadora
            del usuario con el fin de mantener los registros. Las cookies pueden servir para facilitar el uso de un
            sitio web, al guardar contraseñas y preferencias mientras el usuario navega en Internet. Las “web beacons”
            son imágenes insertadas en una página de Internet o correo electrónico, que puede ser utilizado para
            monitorear el comportamiento de un visitante, como almacenar información sobre la dirección IP del usuario,
            duración del tiempo de interacción en dicha página y el tipo de navegador utilizado, entre otros. La mayoría
            de los navegadores aceptan “cookies” y “web beacons” automáticamente, en todo momento, usted podrá elegir no
            recibir un archivo de cookies habilitando su navegador web para que rechace cookies o le informe antes de
            aceptarlas (para obtener detalles, puede consultar www.aboutcookies.org). Tenga en cuenta que las
            preferencias de cookies deben configurarse para cada navegador (Internet Explorer, Google Chrome, Mozilla
            Firefox o Safari).
          </p>
          <h4>2. USOS DE LOS DATOS RECOPILADOS</h4>
          <p>
            Con la aceptación de ésta Política usted autoriza de manera expresa a Netviajes a registrar y tratar su
            información personal para los siguientes fines:
          </p>
          <ul>
            <li>
              {' '}
              Gestionar su reserva turística, llevar a cabo las transacciones incluidas las de procesamiento de pagos
              que usted haya iniciado y procesar facturas u otra documentación fiscal.{' '}
            </li>
            <li>Ofrecerle productos y servicios y responder a sus preguntas y comentarios;</li>
            <li>
              {' '}
              Remitirle confirmación y actualizaciones sobre su viaje, así como cualquier información relevante al
              respecto. Esta información podrá ser remitida vía correo electrónico, SMS o Whatsapp al teléfono celular
              suministrado por usted. Estos mensajes podrán contener (sin limitarse a) información sobre los servicios
              de Netviajes, así como datos de contacto de proveedores que podrían ayudar a su experiencia de viaje en
              destino.
            </li>
            <li>
              {' '}
              Contactarnos con usted para propósitos de servicio al cliente, realizar encuestas, estadísticas o análisis
              sobre hábitos de consumo o preferencias, notificarle por correo electrónico las ofertas especiales y los
              productos y servicios relacionados con viajes que podrían serle de interés salvo que usted no lo desee
              (ver más adelante: política de Desuscripción).
            </li>
          </ul>
          <h4>3. TRATAMIENTO DE DATOS CON TERCEROS</h4>
          <p>
            Usted otorga de manera inequívoca para que Netviajes pueda compartir la Información Personal relevante de
            sus usuarios con proveedores para la gestión de sus reservas y/o solicitudes de compra, tales como
            aerolíneas, hoteles, empresas turísticas que prestan servicios en destino, compañías rentadoras de
            vehículos, mayoristas, y otros proveedores de productos y servicios que usted contrate por nuestro Sitio
            web. Asimismo, usted acepta compartir su Información Personal con proveedores que prestan servicios a
            Netviajes, incluyendo tarjetas de crédito, analítica comercial, servicio de atención al cliente, marketing y
            prevención de fraude.
          </p>
          <p>
            La información y datos personales recolectados son utilizados para procesar, confirmar y cumplir con los
            servicios adquiridos, así como para la realización de la reserva, modificaciones, cancelaciones y cambios de
            itinerario, reembolsos, atención de consultas, quejas y reclamos, pago de compensaciones e indemnizaciones,
            registros contables, correspondencia, procesamiento y verificación de tarjetas de crédito, débito y otros
            instrumentos de pago, promocionar y publicitar nuestras actividades, productos y servicios, realizar
            transacciones financieras de pagos, cobros o reembolsos, atender procedimientos legales, efectuar reportes o
            atender requerimientos de las distintas autoridades administrativas de control y vigilancia nacionales o
            internacionales, autoridades de policía o autoridades judiciales, entidades bancarias y/o compañías
            aseguradoras, para fines administrativos internos y/o comerciales, incluyendo investigación de mercados,
            auditorías, reportes contables, análisis estadísticos, facturación, y ofrecimiento y/o reconocimiento de
            beneficios a través de programas de fidelización, para la ejecución del contrato de transporte y demás
            servicios y actividades complementarias, identificación de fraudes y prevención de lavado de activos y de
            otras actividades delictivas y/o para el funcionamiento de los programas de fidelización y demás finalidades
            indicadas en este documento.
          </p>
          <p>
            En Netviajes no vendemos ni cedemos a terceros por un precio la información y los datos personales de
            nuestros clientes o usuarios. La transferencia de datos que hacemos a terceros en los términos de la
            presente Política se informa que el receptor de los datos personales asumirá las mismas obligaciones que
            corresponden al responsable que transfiere los datos personales, se hace exclusivamente sobre las bases de
            cumplimiento de las finalidades contenidas en la misma. Netviajes no se hace responsable por el uso indebido
            de la Información Personal que pudieran hacer terceras compañías fuera del sitio web. Le ponemos de
            presente, que de conformidad con lo establecido en Artículo 12, Literal d) de la Ley Estatutaria 1581 de
            2012, Netviajes podrá de manera facultativa responder preguntas relacionadas con datos sensibles
            suministrados por usted o con datos de niñas, niños y adolescentes.
          </p>
          <h4>4. ALMACENAMIENTO, TRANSFERENCIA Y TRANSMISIÓN DE DATOS PERSONALES</h4>
          <p>
            Mediante la aceptación de la presente Política usted manifiesta de manera expresa su consentimiento para que
            Netviajes realice el tratamiento de la información, estableciendo que la Información Personal es recolectada
            y almacenada en servidores ubicados físicamente en los Estados Unidos, Argentina y Colombia. Netviajes puede
            reubicar estos servidores en cualquier otro país, en el futuro, y puede almacenar Información Personal en
            los países actuales o en otros países, con fines de respaldo o back up. Usted presta su consentimiento
            inequívoco para que Netviajes pueda transferir o transmitir en calidad de Responsable de su información
            personal sus datos con destino a cualquier país del mundo y a cualquier otro responsable o encargado. En
            cualquier caso, Netviajes se compromete a garantizar por que se cumpla con estándares legalmente exigibles
            para la protección y resguardo de su Información Personal, mediante la firma de acuerdos o convenios cuyo
            objeto sea la privacidad de sus datos personales.
          </p>
          <p>
            La Información Personal será tratada conforme al grado de protección exigible en Colombia y con los
            estándares, procedimientos de seguridad y confidencialidad establecidos por la Ley 1581 de 2012 y el decreto
            reglamentario 1377 de 2013 para garantizar la seguridad de la misma y evitar su alteración, pérdida,
            tratamiento o acceso no autorizado.
          </p>
          <h4>5. CONSULTA, ACTUALIZACIÓN Y/O ELIMINACIÓN DE LA INFORMACIÓN RECOPILADA</h4>
          <h3>5.1 Desuscripción de mensajes promocionales </h3>
          <p>
            Cuando usted realiza transacciones o se registra como usuario en Netviajes, podrá optar por recibir
            circulares promocionales, mensajes o alertas de correo electrónico sobre ofertas. Así mismo, en cada mensaje
            de correo electrónico que le enviemos, usted tendrá la oportunidad de cancelar su suscripción. Usted podrá
            modificar sus elecciones en cualquier momento, siguiendo cualquiera de las alternativas que se explican más
            adelante (“Derechos de Acceso, cancelación, rectificación y oposición de la Información Personal”)
          </p>
          <h3>5.2 Derechos de acceso, cancelación, rectificación y oposición de la información personal</h3>
          <p>
            Los titulares de datos personales por sí o por intermedio de su representante y/o apoderado o su
            causahabiente podrán ejercer los siguientes derechos, respecto de los datos personales que sean objeto de
            tratamiento por parte de Netviajes{' '}
          </p>
          <ul>
            <li>
              {' '}
              Derecho de acceso: En virtud del cual podrá acceder a los datos personales que estén bajo el control de
              Netviajes para efectos de consultarlos de manera gratuita al menos una vez cada mes calendario, y cada vez
              que existan modificaciones sustanciales de las Políticas de Tratamiento de la información que motiven
              nuevas consultas.
            </li>
            <li>
              Derecho de actualización, rectificación y supresión: En virtud del cual podrá solicitar la actualización,
              rectificación y/o supresión de los datos personales objeto de tratamiento, de tal manera que se satisfagan
              los propósitos del tratamiento;
            </li>
            <li>
              Derecho a solicitar prueba de la autorización: salvo en los eventos en los cuales, según las normas
              legales vigentes, no se requiera de la autorización para realizar el tratamiento.
            </li>
            <li>
              Derecho a presentar quejas ante la Superintendencia de Industria y Comercio: por infracciones a lo
              dispuesto en la normatividad vigente sobre tratamiento de datos personales.
            </li>
          </ul>
          <h3> 5.2.1 Rectificación y actualización de datos: </h3>
          <p>
            Netviajes tiene la obligación de rectificar y actualizar a solicitud del titular, la información de éste que
            resulte ser incompleta o inexacta, de conformidad con el procedimiento y los términos arriban señaladas. Al
            respecto se tendrá en cuenta lo siguiente: En las solicitudes de rectificación y actualización de datos
            personales el titular debe indicar las correcciones a realizar y aportar la documentación que avale su
            petición.
          </p>
          <h3>5.2.2 Supresión de datos: </h3>
          <p>
            {' '}
            El titular tiene el derecho, en todo momento, a solicitar a Netviajes la supresión (eliminación) de sus
            datos personales cuando:{' '}
          </p>
          <ul>
            <li>
              Considere que los mismos no están siendo tratados conforme a los principios, deberes y obligaciones
              previstas en la normatividad vigente.
            </li>
            <li>Hayan dejado de ser necesarios o pertinentes para la finalidad para la cual fueron recabados.</li>
            <li>
              Se haya superado el periodo necesario para el cumplimiento de los fines para los que fueron recabados.{' '}
            </li>
          </ul>
          <p>
            Esta supresión implica la eliminación total o parcial de la información personal de acuerdo con lo
            solicitado por el titular en los registros, archivos, bases de datos o tratamientos realizados por
            Netviajes.
          </p>
          <p>
            Es importante tener en cuenta que el derecho de cancelación no es absoluto y el responsable puede negar el
            ejercicio del mismo cuando:{' '}
          </p>
          <ul>
            <li>El titular tenga un deber legal o contractual de permanecer en la base de datos. </li>
            <li>
              La eliminación de datos obstaculice actuaciones judiciales o administrativas vinculadas a obligaciones
              fiscales, la investigación y persecución de delitos o la actualización de sanciones administrativas.{' '}
            </li>
            <li>
              Los datos sean necesarios para proteger los intereses jurídicamente tutelados del titular; para realizar
              una acción en función del interés público, o para cumplir con una obligación legalmente adquirida por el
              titular.{' '}
            </li>
          </ul>
          <h3>5.3 Deberes de Netviajes</h3>
          <p>
            Netviajes tendrá presente, en todo momento, que los datos personales son propiedad de las personas a las que
            se refieren y que sólo ellas pueden decidir sobre los mismos. En este sentido, hará uso de ellos sólo para
            aquellas finalidades para las que se encuentra facultado debidamente, y respetando en todo caso la
            normatividad vigente sobre protección de datos personales. A. Deberes cuando actúa como responsable:
          </p>
          <ul>
            <li>
              Solicitar y conservar, en las condiciones previstas en esta política, copia de la respectiva autorización
              otorgada por el titular.{' '}
            </li>
            <li>
              Informar de manera clara y suficiente al titular sobre la finalidad de la recolección y los derechos que
              le asisten por virtud de la autorización otorgada.
            </li>
          </ul>
          <h3>5.4 Deberes cuando obra como Encargado del tratamiento de datos personales. </h3>
          <p>
            Si realiza el tratamiento de datos en nombre de otra entidad u organización (Responsable del tratamiento)
            deberá cumplir los siguientes deberes:{' '}
          </p>
          <ul>
            <li>
              Establecer que el Responsable del tratamiento esté autorizado para suministrar los datos personales que
              tratará como Encargado.{' '}
            </li>
            <li>Garantizar al titular, en todo tiempo, el pleno y efectivo ejercicio del derecho de hábeas data. </li>
            <li>
              Conservar la información bajo las condiciones de seguridad necesarias para impedir su adulteración,
              pérdida, consulta, uso o acceso no autorizado o fraudulento.{' '}
            </li>
            <li>Realizar oportunamente la actualización, rectificación o supresión de los datos. </li>
            <li>
              Abstenerse de circular información que esté siendo controvertida por el titular y cuyo bloqueo haya sido
              ordenado por la Superintendencia de Industria y Comercio.{' '}
            </li>
            <li>
              Permitir el acceso a la información únicamente a las personas autorizadas por el titular o facultadas por
              la ley para dicho efecto.
            </li>
          </ul>
          <h3>5.5 Deberes respecto de la Superintendencia de Industria y Comercio </h3>
          <ul>
            <li>
              Informarle las eventuales violaciones a los códigos de seguridad y la existencia de riesgos en la
              administración de la información de los titulares.{' '}
            </li>
            <li>Cumplir las instrucciones y requerimientos que imparta la Superintendencia de Industria y Comercio.</li>
          </ul>
          <h4>6. LIMITACIONES TEMPORALES AL TRATAMIENTO DE LOS DATOS PERSONALES </h4>
          <p>
            Solo podrá recolectar, almacenar, usar o circular los datos personales durante el tiempo que sea razonable y
            necesario, de acuerdo con las finalidades que justificaron el tratamiento, atendiendo a las disposiciones
            aplicables a la materia de que se trate y a los aspectos administrativos, contables, fiscales, jurídicos e
            históricos de la información.
          </p>
          <p>
            Una vez cumplida la o las finalidades del tratamiento y sin perjuicio de normas legales que dispongan lo
            contrario, procederá a la supresión de los datos personales en su posesión. No obstante lo anterior, los
            datos personales deberán ser conservados cuando así se requiera para el cumplimiento de una obligación legal
            o contractual.
          </p>
          <h4>7. PROCEDIMIENTO PARA EL EJERCICIO DE LOS DERECHOS DE LOS TITULARES DE LOS DATOS PERSONALES</h4>
          <p>
            El titular del dato personal o quien ejerza su representación podrá enviar su petición, queja o reclamo de
            lunes a viernes en horario hábil, al correo electrónico privacidad@netviaje.co o radicar la solicitud en la
            dirección Carrera 15 # 88-21 Of.502 en Bogotá.
          </p>
          <h3>Procedimiento:</h3>
          <p>Los derechos de rectificación, actualización o supresión únicamente se podrán ejercer por: </p>
          <ul>
            <li>
              {' '}
              El titular o sus causahabientes, previa acreditación de su identidad, o a través de instrumentos
              electrónicos que le permitan identificarse.{' '}
            </li>
            <li>
              {' '}
              Su representante, previa acreditación de la representación. Cuando la solicitud sea formulada por persona
              distinta del titular, deberá acreditarse en debida forma la personería o mandato para actuar; y en caso de
              no acreditar tal calidad, la solicitud se tendrá por no presentada.
            </li>
          </ul>
          <p>
            La petición, queja o reclamo deberá contener la identificación del Titular, la descripción de los hechos que
            dan lugar al reclamo, la dirección, y acompañando los documentos que se quiera hacer valer. Si el reclamo
            resulta incompleto, se requerirá al interesado dentro de los cinco (5) días siguientes a la recepción del
            reclamo para que subsane las fallas.
          </p>
          <p>
            Transcurridos dos (2) meses desde la fecha del requerimiento, sin que el solicitante presente la información
            requerida, se entenderá que ha desistido del reclamo. En caso de que quien reciba el reclamo no sea
            competente para resolverlo, dará traslado a quien corresponda en un término máximo de dos (2) días hábiles e
            informará de la situación al interesado.
          </p>
          <p>
            Una vez recibido el reclamo completo, se incluirá en la base de datos una leyenda que diga “reclamo en
            trámite” y el motivo del mismo, en un término no mayor a dos (2) días hábiles. Dicha leyenda deberá
            mantenerse hasta que el reclamo sea decidido.
          </p>
          <p>
            El término máximo para atender el reclamo será de quince (15) días hábiles contados a partir del día
            siguiente a la fecha de su recibo. Cuando no fuere posible atender el reclamo dentro de dicho término, se
            informará al interesado los motivos de la demora y la fecha en que se atenderá su reclamo, la cual en ningún
            caso podrá superar los ocho (8) días hábiles siguientes al vencimiento del primer término.
          </p>
          <h4>
            8. AUTORIZACIÓN PARA LA CONSULTA Y EL PROCESAMIENTO DE DATOS FINANCIEROS EN CENTRALES DE RIESGO CREDITICIO.{' '}
          </h4>
          <p>
            Con la aceptación de la presente Política de Privacidad, usted autoriza de manera expresa e irrevocable,
            libre y voluntariamente a Netviajes o a quien represente sus derechos u ostente en el futuro a cualquier
            título la calidad de acreedor, para que reporte, consulte y divulgue a la Asociación Bancaria y de Entidades
            Financieras de Colombia ASOBANCARIA, o a cualquier otro operador y/o fuente de información legalmente
            establecido, toda la información referente a su comportamiento como cliente que se relacione con el
            nacimiento, ejecución, modificación, liquidación y/o extinción de las obligaciones que se deriven del
            presente contrato, en cualquier tiempo, y que podrá reflejarse en las bases de datos de la CIFIN o de
            cualquier otro operador y/o fuente de información legalmente establecido. La permanencia de la información
            estará sujeta a los principios, términos y condiciones consagrados en la ley 1266 de 2008, ley 1581 de 2012
            y demás normas que lo modifiquen, aclaren o reglamenten. Así mismo, autoriza, expresa e irrevocablemente a
            Netviajes para que consulte toda la información financiera, crediticia, comercial, de servicios y la
            proveniente de otros países, atinente a las relaciones comerciales que tenga con el Sistema Financiero,
            comercial y de servicios, o de cualquier sector, tanto en Colombia como en el Exterior, en cualquier tiempo.
          </p>
          <p>
            La presente autorización se extiende para que Netviajes pueda compartir su información financiera con
            terceros públicos o privados, bien sea que éstos ostenten la condición de fuentes de información, operadores
            de información o usuarios, con quienes usted tenga vínculos jurídicos de cualquier naturaleza, todo conforme
            a lo establecido en la legislación vigente en Colombia en materia de protección de datos personales.
          </p>
          <h4>9. MEDIDAS DE SEGURIDAD</h4>
          <p>
            En desarrollo del principio de seguridad establecido en la Ley 1581 de 2012, la Netviajes adoptará las
            medidas técnicas, humanas y administrativas que sean necesarias para otorgar seguridad a los registros
            evitando su adulteración, pérdida, consulta, uso o acceso no autorizado o fraudulento. El personal que
            realice el tratamiento de los datos personales ejecutará los protocolos establecidos con el fin de
            garantizar la seguridad de la información.
          </p>
          <h4>10. FECHA DE ENTRADA EN VIGENCIA</h4>
          <p>
            La presente versión del manual de políticas de tratamiento de información entra en vigencia a partir de su
            publicación en el Sitio web de la empresa.{' '}
          </p>
        </div>
      </>
    )}
  </>
);

export default Privacy;
